import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Instagram } from "lucide-react";
import { NAV, PHONE, ADDRESS, INSTAGRAM } from "@/data/content";

export const Footer = () => (
  <footer className="border-t border-gold/15 bg-midnight pt-20 pb-10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 grid gap-12 md:grid-cols-4">
      <div className="md:col-span-2">
        <span className="font-serif text-2xl gold-text">Spunky Scissors</span>
        <p className="font-label text-[10px] text-white/50 mt-1">Unisex Salon &amp; Academy</p>
        <p className="text-white/70 mt-5 max-w-sm leading-relaxed">Beauty is an Art. We Make It Extraordinary. Bangalore's luxury destination for hair, beauty, makeup, nails &amp; professional beauty education.</p>
      </div>
      <div>
        <h4 className="text-gold text-lg mb-4">Explore</h4>
        <ul className="space-y-2.5">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} className="text-white/70 hover:text-gold transition-colors text-sm">{n.label}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-gold text-lg mb-4">Visit Us</h4>
        <p className="flex gap-2 text-white/70 text-sm mb-3"><MapPin size={18} className="text-gold shrink-0" />{ADDRESS}</p>
        <a href={`tel:${PHONE.replace(/ /g,'')}`} className="flex gap-2 text-white/70 hover:text-gold text-sm mb-3"><Phone size={18} className="text-gold" />{PHONE}</a>
        <a href={`https://instagram.com/${INSTAGRAM}`} target="_blank" rel="noreferrer" className="flex gap-2 text-white/70 hover:text-gold text-sm"><Instagram size={18} className="text-gold" />@{INSTAGRAM}</a>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-white/40 text-xs">
      <span>© {new Date().getFullYear()} Spunky Scissors Unisex Salon &amp; Academy. All rights reserved.</span>
      <span>Best Unisex Salon &amp; Makeup Academy in HRBR Layout, Kalyan Nagar, Bangalore.</span>
    </div>
  </footer>
);
